!(function (global) {

    $(document).on('ready JsPhotoCounter::init', function () {

        var $jsPhotoCounter    = $('.js-photo-counter');
        var $notInitedCounters = $jsPhotoCounter.filter(function () { return !$(this).data('jsPhotoCounter') });
        var jsPhotoCounters    = _(window.jsPhotoCounters).chain().flatten().uniq(function (item) {
            return JSON.stringify(item);
        }).value();

        if ($notInitedCounters.length > 0) {
            debug.log('We’ve not inited js photos counters!..', $notInitedCounters);

            $notInitedCounters.each(function () {
                var $counter      = $(this);
                var $templateNode = $counter.find('.js-photo-counter__template');

                if ($templateNode.length > 0) {
                    var $template = $templateNode.html();
                    var data      = _(jsPhotoCounters).findWhere({ id : Number($counter.data('photoId')) });

                    debug.log('... got counter...', { $counter : $counter, $template: $template, data : data });

                    if (!_(data).isObject()) {

                        if (window.ErrorLogger) {
                            window.ErrorLogger.sendError(
                                'JS photo counter w/o data',
                                {
                                    photoId: $counter.data("photoId")
                                }
                            );
                        }
                    }
                    else {
                        $templateNode.replaceWith(_.template($template, data));
                        $counter.data('jsPhotoCounter', {
                            $template : $template,
                            data      : data
                        });
                        debug.log('... done!', $counter, $templateNode);

                        $counter.on('JsPhotoCounter::update', function () {
                            var $templateNode = $counter.find('.js-photo-counter__template');
                            $templateNode.replaceWith(_.template($template, data));
                        });
                    }
                }
                else {

                    if (window.ErrorLogger) {

                        window.ErrorLogger.sendError(
                            'JS photo counter does not have a template',
                            {
                                photoId: 'Photo ID: ' + $counter.data("photoId")
                            }
                        );
                    }
                }
            });
        }
    });

})(window);